import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import CustomTable from "../../common/CustomTable";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function CouriersList(props) {
  const {
    couriers,
    courierNames,
    handleEditClick,
    handleCouriersChange,
    handleStatusChange,
    statusNames,
    statusList,
    handleSearch,
    handleEdit,
    handleClear,
    selectNames,
    rowList,
    setRowList,
    headCells,
    productsAmount,
    handleMore,
    page,
    setPage,
    handleRequestSort,
    sortProperty,
    sortDirection,
    rowsPerPage,
    setRowsPerPage,
    getFullList,
  } = props;
  const classes = useStyles();

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  return (
    <div className={classes.root}>
      <CustomTable
        data={couriers.couriersList}
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={"courier"}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={productsAmount}
        handleMore={handleMore}
        page={page}
        setPage={setPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullList}
      />
    </div>
  );
}
